(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@shraddhar/web/form-field'), require('@angular/cdk/coercion'), require('@angular/cdk/collections'), require('@angular/cdk/platform'), require('@material/ripple'), require('@material/radio'), require('@shraddhar/web/ripple'), require('@shraddhar/web/base'), require('@angular/forms')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/web/radio', ['exports', '@angular/core', '@shraddhar/web/form-field', '@angular/cdk/coercion', '@angular/cdk/collections', '@angular/cdk/platform', '@material/ripple', '@material/radio', '@shraddhar/web/ripple', '@shraddhar/web/base', '@angular/forms'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.web = global.shraddhar.web || {}, global.shraddhar.web.radio = {}), global.ng.core, global.ng.web.formField, global.ng.cdk.coercion, global.ng.cdk.collections, global.ng.cdk.platform, global.mdc.ripple, global.mdc.radio, global.ng.web.ripple, global.ng.web.base, global.ng.forms));
}(this, (function (exports, core, formField, coercion, collections, platform, ripple, radio, ripple$1, base, forms) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    /**
     * Injection token used to provide the parent MdcRadioGroup component to MdcRadio.
     */
    var MDC_RADIO_GROUP_PARENT_COMPONENT = new core.InjectionToken('MDC_RADIO_GROUP_PARENT_COMPONENT');
    /** Change event object emitted by MdcRadio. */
    var MdcRadioChange = /** @class */ (function () {
        function MdcRadioChange(
        /** The source MdcRadio of the event. */
        source, 
        /** The value of the radio button. */
        value) {
            this.source = source;
            this.value = value;
        }
        return MdcRadioChange;
    }());
    var nextUniqueId = 0;
    var MdcRadio = /** @class */ (function (_super) {
        __extends(MdcRadio, _super);
        function MdcRadio(_changeDetectorRef, elementRef, ripple, _radioDispatcher, radioGroup, _parentFormField) {
            var _this = _super.call(this, elementRef) || this;
            _this._changeDetectorRef = _changeDetectorRef;
            _this.elementRef = elementRef;
            _this.ripple = ripple;
            _this._radioDispatcher = _radioDispatcher;
            _this.radioGroup = radioGroup;
            _this._parentFormField = _parentFormField;
            _this._uniqueId = "mdc-radio-" + ++nextUniqueId;
            _this._initialized = false;
            /** The unique ID for the radio button. */
            _this.id = _this._uniqueId;
            _this.tabIndex = 0;
            _this._touch = false;
            _this._checked = false;
            _this._disabled = false;
            _this._required = false;
            _this.change = new core.EventEmitter();
            /** Unregister function for _radioDispatcher */
            _this._removeUniqueSelectionListener = function () { };
            if (_this._parentFormField) {
                _parentFormField.elementRef.nativeElement.classList.add('mdc-form-field');
            }
            _this._root = elementRef.nativeElement;
            _this.ripple = _this._createRipple();
            _this._removeUniqueSelectionListener =
                _radioDispatcher.listen(function (id, name) {
                    if (id !== _this.id && name === _this.name) {
                        // Get the checked state from native radio button. The native radio buttons with the same
                        // name have separate unique selection in different form containers.
                        _this.checked = _this.input.nativeElement.checked;
                    }
                });
            return _this;
        }
        Object.defineProperty(MdcRadio.prototype, "inputId", {
            get: function () {
                return (this.id || this._uniqueId) + "-input";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRadio.prototype, "touch", {
            get: function () {
                return this._touch;
            },
            set: function (value) {
                this._touch = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRadio.prototype, "value", {
            get: function () {
                return this._value;
            },
            set: function (newValue) {
                this.setValue(newValue);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRadio.prototype, "checked", {
            get: function () {
                return this._checked;
            },
            set: function (value) {
                this.setChecked(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRadio.prototype, "disabled", {
            get: function () {
                return this._disabled || (this.radioGroup !== null && this.radioGroup.disabled);
            },
            set: function (value) {
                var newDisabledState = coercion.coerceBooleanProperty(value);
                if (this._disabled !== newDisabledState) {
                    this._disabled = newDisabledState;
                    this._foundation.setDisabled(this._disabled);
                    this._changeDetectorRef.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRadio.prototype, "required", {
            get: function () {
                return this._required || (this.radioGroup && this.radioGroup.required);
            },
            set: function (value) {
                this._required = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcRadio.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this._root.classList.add(className); },
                removeClass: function (className) { return _this._root.classList.remove(className); },
                setNativeControlDisabled: function (disabled) { return _this.disabled = disabled; }
            };
            return new radio.MDCRadioFoundation(adapter);
        };
        MdcRadio.prototype.ngAfterViewInit = function () {
            var _this = this;
            this._initialized = true;
            this._foundation.init();
            if (this.radioGroup) {
                Promise.resolve().then(function () {
                    // If the radio is inside a radio group, determine if it should be checked
                    _this.checked = _this.radioGroup.value === _this._value;
                    // Copy name from parent radio group
                    _this.name = _this.radioGroup.name;
                    _this.setChecked(_this.checked);
                    _this._changeDetectorRef.markForCheck();
                });
            }
        };
        MdcRadio.prototype.ngOnDestroy = function () {
            this._removeUniqueSelectionListener();
            this.ripple.destroy();
            this._foundation.destroy();
        };
        MdcRadio.prototype.onInputClick = function (event) {
            // Preventing bubbling for the second event will solve that issue.
            event.stopPropagation();
        };
        MdcRadio.prototype.onInputChange = function (event) {
            this.ripple.init();
            event.stopPropagation();
            var groupValueChanged = this.radioGroup && this.value !== this.radioGroup.value;
            this.checked = true;
            this._emitChangeEvent();
            if (this.radioGroup) {
                this.radioGroup._controlValueAccessorChangeFn(this.value);
                if (groupValueChanged) {
                    this.radioGroup.emitChangeEvent();
                }
            }
        };
        MdcRadio.prototype.setChecked = function (checked) {
            if (!this._initialized) {
                return;
            }
            var newCheckedState = coercion.coerceBooleanProperty(checked);
            if (this._checked !== newCheckedState) {
                this._checked = newCheckedState;
                this.input.nativeElement.checked = newCheckedState;
                if (newCheckedState && this.radioGroup && this.radioGroup.value !== this.value) {
                    this.radioGroup.selected = this;
                }
                else if (!newCheckedState && this.radioGroup && this.radioGroup.value === this.value) {
                    // When unchecking the selected radio button, update the selected radio
                    // property on the group.
                    this.radioGroup.selected = null;
                }
                this._changeDetectorRef.markForCheck();
                if (newCheckedState) {
                    // Notify all radio buttons with the same name to un-check.
                    this._radioDispatcher.notify(this.id, this.name);
                }
            }
        };
        MdcRadio.prototype.setValue = function (value) {
            this._value = value;
            this.input.nativeElement.value = this._value;
            if (this.radioGroup !== null) {
                if (!this.checked) {
                    // Update checked when the value changed to match the radio group's value
                    this.checked = this.radioGroup.value === value;
                }
                if (this.checked) {
                    this.radioGroup.selected = this;
                }
            }
        };
        MdcRadio.prototype.focus = function () {
            this.input.nativeElement.focus();
        };
        MdcRadio.prototype.markForCheck = function () {
            this._changeDetectorRef.markForCheck();
        };
        MdcRadio.prototype._createRipple = function () {
            var _this = this;
            var adapter = __assign(__assign({}, ripple$1.MdcRipple.createAdapter(this)), { isSurfaceActive: function () { return false; }, isUnbounded: function () { return true; }, deregisterInteractionHandler: function (evtType, handler) {
                    return _this.input.nativeElement.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                }, registerInteractionHandler: function (evtType, handler) {
                    return _this.input.nativeElement.addEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                } });
            return new ripple$1.MdcRipple(this.elementRef, new ripple.MDCRippleFoundation(adapter));
        };
        /** Dispatch change event with current value. */
        MdcRadio.prototype._emitChangeEvent = function () {
            this.change.emit(new MdcRadioChange(this, this._value));
        };
        MdcRadio.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-radio',
                        exportAs: 'mdcRadio',
                        host: {
                            '[id]': 'id',
                            'class': 'mdc-radio',
                            '(focus)': 'input.nativeElement.focus()',
                            '[attr.tabindex]': '-1',
                            '[attr.name]': 'null',
                            '[class.mdc-radio--touch]': 'touch',
                        },
                        template: "<input type=\"radio\"\r\n  #input\r\n  class=\"mdc-radio__native-control\"\r\n  [id]=\"inputId\"\r\n  [attr.name]=\"name\"\r\n  [tabIndex]=\"tabIndex\"\r\n  [attr.aria-label]=\"ariaLabel\"\r\n  [attr.aria-labelledby]=\"ariaLabelledby\"\r\n  [attr.aria-describedby]=\"ariaDescribedby\"\r\n  [disabled]=\"disabled\"\r\n  [required]=\"required\"\r\n  [checked]=\"checked\"\r\n  (click)=\"onInputClick($event)\"\r\n  (change)=\"onInputChange($event)\" />\r\n<div class=\"mdc-radio__background\">\r\n  <div class=\"mdc-radio__outer-circle\"></div>\r\n  <div class=\"mdc-radio__inner-circle\"></div>\r\n</div>\r\n<div class=\"mdc-radio__ripple\"></div>",
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        providers: [
                            ripple$1.MdcRipple,
                            { provide: formField.MdcFormFieldControl, useExisting: MdcRadio }
                        ]
                    }] }
        ];
        /** @nocollapse */
        MdcRadio.ctorParameters = function () { return [
            { type: core.ChangeDetectorRef },
            { type: core.ElementRef },
            { type: ripple$1.MdcRipple },
            { type: collections.UniqueSelectionDispatcher },
            { type: undefined, decorators: [{ type: core.Optional }, { type: core.Inject, args: [MDC_RADIO_GROUP_PARENT_COMPONENT,] }] },
            { type: formField.MdcFormField, decorators: [{ type: core.Optional }] }
        ]; };
        MdcRadio.propDecorators = {
            id: [{ type: core.Input }],
            name: [{ type: core.Input }],
            tabIndex: [{ type: core.Input }],
            ariaLabel: [{ type: core.Input, args: ['aria-label',] }],
            ariaLabelledby: [{ type: core.Input, args: ['aria-labelledby',] }],
            ariaDescribedby: [{ type: core.Input, args: ['aria-describedby',] }],
            touch: [{ type: core.Input }],
            value: [{ type: core.Input }],
            checked: [{ type: core.Input }],
            disabled: [{ type: core.Input }],
            required: [{ type: core.Input }],
            change: [{ type: core.Output }],
            input: [{ type: core.ViewChild, args: ['input', { static: true },] }]
        };
        return MdcRadio;
    }(base.MDCComponent));

    /**
     * Provider Expression that allows mdc-radio-group to register as a ControlValueAccessor. This
     * allows it to support [(ngModel)] and ngControl.
     */
    var MDC_RADIO_GROUP_CONTROL_VALUE_ACCESSOR = {
        provide: forms.NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return MdcRadioGroup; }),
        multi: true
    };
    var nextUniqueId$1 = 0;
    var MdcRadioGroup = /** @class */ (function () {
        function MdcRadioGroup(_changeDetectorRef, elementRef) {
            this._changeDetectorRef = _changeDetectorRef;
            this.elementRef = elementRef;
            this._name = "mdc-radio-group-" + nextUniqueId$1++;
            /** Selected value for the radio group. */
            this._value = null;
            /** Whether the `value` has been set to its initial value. */
            this._isInitialized = false;
            this._selected = null;
            this._required = false;
            this._disabled = false;
            /** The method to be called in order to update ngModel */
            this._controlValueAccessorChangeFn = function () { };
            /** onTouch function registered via registerOnTouch (ControlValueAccessor). */
            this.onTouched = function () { };
            this.change = new core.EventEmitter();
        }
        Object.defineProperty(MdcRadioGroup.prototype, "name", {
            /** Name of the radio button group. All radio buttons inside this group will use this name. */
            get: function () { return this._name; },
            set: function (value) {
                this._name = value;
                this._updateRadioButtonNames();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRadioGroup.prototype, "value", {
            /**
             * Value for the radio-group. Should equal the value of the selected radio button if there is
             * a corresponding radio button with a matching value. If there is not such a corresponding
             * radio button, this value persists to be applied in case a new radio button is added with a
             * matching value.
             */
            get: function () { return this._value; },
            set: function (newValue) {
                if (this._value !== newValue) {
                    // Set this before proceeding to ensure no circular loop occurs with selection.
                    this._value = newValue;
                    this._updateSelectedRadioFromValue();
                    this._checkSelectedRadioButton();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRadioGroup.prototype, "selected", {
            /**
             * The currently selected radio button. If set to a new radio button, the radio group value
             * will be updated to match the new selected button.
             */
            get: function () { return this._selected; },
            set: function (selected) {
                this._selected = selected;
                this.value = selected ? selected.value : null;
                this._checkSelectedRadioButton();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRadioGroup.prototype, "required", {
            get: function () { return this._required; },
            set: function (value) {
                this._required = coercion.coerceBooleanProperty(value);
                this._markRadiosForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRadioGroup.prototype, "disabled", {
            get: function () { return this._disabled; },
            set: function (value) {
                this._disabled = coercion.coerceBooleanProperty(value);
                this._updateDisableRadioState(this._disabled);
                this._markRadiosForCheck();
            },
            enumerable: true,
            configurable: true
        });
        MdcRadioGroup.prototype._checkSelectedRadioButton = function () {
            if (this._selected && !this._selected.checked) {
                this._selected.checked = true;
            }
        };
        MdcRadioGroup.prototype.ngAfterContentInit = function () {
            this._isInitialized = true;
        };
        MdcRadioGroup.prototype._touch = function () {
            if (this.onTouched) {
                this.onTouched();
            }
        };
        MdcRadioGroup.prototype._updateRadioButtonNames = function () {
            var _this = this;
            if (this._radios) {
                this._radios.forEach(function (radio) {
                    radio.name = _this.name;
                    radio.markForCheck();
                });
            }
        };
        /** Updates the `selected` radio button from the internal _value state. */
        MdcRadioGroup.prototype._updateSelectedRadioFromValue = function () {
            var _this = this;
            // If the value already matches the selected radio, do nothing.
            var isAlreadySelected = this._selected !== null && this._selected.value === this._value;
            if (this._radios && !isAlreadySelected) {
                this._selected = null;
                this._radios.forEach(function (radio) {
                    radio.checked = _this.value === radio.value;
                    if (radio.checked) {
                        _this._selected = radio;
                    }
                });
            }
        };
        MdcRadioGroup.prototype._markRadiosForCheck = function () {
            if (this._radios) {
                this._radios.forEach(function (radio) { return radio.markForCheck(); });
            }
        };
        MdcRadioGroup.prototype._updateDisableRadioState = function (disabled) {
            if (this._radios) {
                this._radios.forEach(function (radio) { return radio.disabled = disabled; });
            }
        };
        /** Sets the model value. Implemented as part of ControlValueAccessor. */
        MdcRadioGroup.prototype.writeValue = function (value) {
            this.value = value;
            this._changeDetectorRef.markForCheck();
        };
        /**
         * Registers a callback to be triggered when the model value changes.
         * Implemented as part of ControlValueAccessor.
         * @param fn Callback to be registered.
         */
        MdcRadioGroup.prototype.registerOnChange = function (fn) {
            this._controlValueAccessorChangeFn = fn;
        };
        /**
         * Registers a callback to be triggered when the control is touched.
         * Implemented as part of ControlValueAccessor.
         * @param fn Callback to be registered.
         */
        MdcRadioGroup.prototype.registerOnTouched = function (fn) {
            this.onTouched = fn;
        };
        /**
         * Sets the disabled state of the control. Implemented as a part of ControlValueAccessor.
         * @param isDisabled Whether the control should be disabled.
         */
        MdcRadioGroup.prototype.setDisabledState = function (isDisabled) {
            this.disabled = coercion.coerceBooleanProperty(isDisabled);
            this._changeDetectorRef.markForCheck();
        };
        /** Dispatch change event with current selection and group value. */
        MdcRadioGroup.prototype.emitChangeEvent = function () {
            if (this._isInitialized) {
                this.change.emit(new MdcRadioChange(this._selected, this._value));
            }
        };
        MdcRadioGroup.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-radio-group, [mdcRadioGroup]',
                        exportAs: 'mdcRadioGroup',
                        host: {
                            'role': 'radiogroup',
                            '[attr.name]': 'null'
                        },
                        template: '<ng-content></ng-content>',
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None,
                        providers: [MDC_RADIO_GROUP_CONTROL_VALUE_ACCESSOR,
                            { provide: MDC_RADIO_GROUP_PARENT_COMPONENT, useExisting: MdcRadioGroup }
                        ]
                    }] }
        ];
        /** @nocollapse */
        MdcRadioGroup.ctorParameters = function () { return [
            { type: core.ChangeDetectorRef },
            { type: core.ElementRef }
        ]; };
        MdcRadioGroup.propDecorators = {
            _radios: [{ type: core.ContentChildren, args: [core.forwardRef(function () { return MdcRadio; }), { descendants: true },] }],
            name: [{ type: core.Input }],
            value: [{ type: core.Input }],
            selected: [{ type: core.Input }],
            required: [{ type: core.Input }],
            disabled: [{ type: core.Input }],
            change: [{ type: core.Output }]
        };
        return MdcRadioGroup;
    }());

    var MdcRadioModule = /** @class */ (function () {
        function MdcRadioModule() {
        }
        MdcRadioModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [formField.MdcFormFieldModule],
                        exports: [MdcRadioGroup, MdcRadio, formField.MdcFormFieldModule],
                        declarations: [MdcRadioGroup, MdcRadio]
                    },] }
        ];
        return MdcRadioModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MDC_RADIO_GROUP_CONTROL_VALUE_ACCESSOR = MDC_RADIO_GROUP_CONTROL_VALUE_ACCESSOR;
    exports.MDC_RADIO_GROUP_PARENT_COMPONENT = MDC_RADIO_GROUP_PARENT_COMPONENT;
    exports.MdcRadio = MdcRadio;
    exports.MdcRadioChange = MdcRadioChange;
    exports.MdcRadioGroup = MdcRadioGroup;
    exports.MdcRadioModule = MdcRadioModule;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-radio.umd.js.map
